import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useNavigate } from "react-router-dom";

const cardSx = {
  p: 3,
  borderRadius: 1.5,
  boxShadow: (theme) => theme.palette.shadow.statCard,
  border: (theme) => `1px solid ${theme.palette.border.light}`,
  bgcolor: "background.paper",
  height: "100%",
};

const ActionTile = ({ icon, label, active, onClick }) => (
  <Paper
    elevation={0}
    onClick={onClick}
    sx={{
      p: 3,
      borderRadius: 1.5,
      border: (theme) => `1px solid ${theme.palette.border.light}`,
      bgcolor: (theme) =>
        active ? theme.palette.accent.cyan.bgLight : "background.paper",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.2s",
      "&:hover": {
        borderColor: (theme) => theme.palette.accent.teal.chipText,
      },
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        bgcolor: (theme) =>
          active
            ? theme.palette.accent.teal.chipText
            : theme.palette.text.neutral,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1.5,
      }}
    >
      {React.cloneElement(icon, {
        sx: { color: "common.white", fontSize: 22 },
      })}
    </Box>
    <Typography
      fontSize={14}
      fontWeight={600}
      sx={{ color: "text.primary" }}
    >
      {label}
    </Typography>
  </Paper>
);

const InvestorQuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    { key: "discover", label: "Discover Assets", icon: <AutoAwesomeIcon />, to: "/investor/viewinvest" },
    // { key: "portfolio", label: "My Portfolio", icon: <AccountBalanceWalletOutlinedIcon />, to: "/investor/portfolio" },
    // { key: "documents", label: "Documents", icon: <DescriptionOutlinedIcon />, to: "/investor/documents" },
    // { key: "income", label: "Income", icon: <SarIcon />, to: "/investor/income" },
  ];

  return (
    <Paper elevation={0} sx={cardSx}>
      <Typography
        variant="subtitle1"
        fontWeight={700}
        sx={{ color: "text.primary", mb: 2 }}
      >
        Quick Actions
      </Typography>
      <Grid container spacing={2}>
        {actions.map((a) => (
          <Grid size={{ xs: 12, sm: 6 }} key={a.key}>
            <ActionTile {...a} onClick={() => { navigate(a.to); window.scrollTo({ top: 0, behavior: "smooth" }); }} />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default InvestorQuickActions;